<!--  -->
<template>
    <router-view />
</template>

<script>
export default {
  components: {},
  props: [],
  data () {
    return {
    };
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>

</style>
